module.exports = __webpack_public_path__ + "static/media/splits.5035e86d.mp3";